// src/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://citadel.hikesocietycam.com/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 120000
});

const token = localStorage.getItem('token');
if (token) {
  instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Interceptor de solicitudes
instance.interceptors.request.use(
  (config) => {
    // Agregar timestamp para prevenir cacheo
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
    }
    
    // Validación de CSRF para peticiones no GET
    if (config.method !== 'get' && document.cookie.includes('XSRF-TOKEN')) {
      const csrfToken = getCookie('XSRF-TOKEN');
      config.headers['X-XSRF-TOKEN'] = csrfToken;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuestas
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Si el error es 419 (CSRF token expirado) o 401 (token expirado) y no hemos intentado refresh
    if ((error.response?.status === 419 || error.response?.status === 401) && 
        !originalRequest._retry && 
        localStorage.getItem('token')) {
      
      originalRequest._retry = true;
      
      try {
        // Intento de refresh token
        const response = await instance.post('/auth/refresh');
        
        if (response.data.token) {
          // Actualizar token
          localStorage.setItem('token', response.data.token);
          instance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
          
          // Reintento de la petición original
          return instance(originalRequest);
        }
      } catch (refreshError) {
        // Si el refresh falla, cerrar sesión
        localStorage.removeItem('token');
        delete instance.defaults.headers.common['Authorization'];
        
        // Importación dinámica para evitar ciclo de dependencias
        import('./stores/auth').then(({ useAuthStore }) => {
          const authStore = useAuthStore();
          authStore.user = null;
          authStore.token = null;
          
          // Si no estamos en la página de login, redirigir
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        });
      }
    }
    
    return Promise.reject(error);
  }
);

// Utilidad para obtener cookies por nombre
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export default instance;